import { TOAST_MESSAGE_SEVERITY_ERROR } from 'modules/layout/types';
import { UPDATE_LISTINGS_FAILURE } from 'modules/authorizations/store/types/homesaleTypes';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { showToast } from 'modules/layout/layout.actions';
import { getHomesaleInfo, updateEquity } from 'modules/authorizations/store/actions/homesale.actions';
import EditableCard from 'modules/common/editableCard.component';
import React, { useState } from 'react';
import { ZERO_GUID } from 'modules/enumerations/enumerationIds';

const EquityDetailsCard = props => {
  const [isLoading, setIsLoading] = useState(false);

  const { equity, isReadOnly, prorationDayesTypesEnum, fileId } = props;
  const equityInfo = equity ? equity.equityInfo : null;

  const tabs = [
    { header: 'Primary Mortgage', order: 1, iconPath: ['fas', 'file-contract'] },
    { header: 'Secondary Mortgage', order: 2, iconPath: ['fas', 'file-contract'] }
    // { header: 'Other Loans', order: 3, iconPath: ['fas', 'file-contract'] }
  ];

  const prorationDaysOptions =
    prorationDayesTypesEnum && prorationDayesTypesEnum.length > 0
      ? prorationDayesTypesEnum.filter(s => s.isActive === true)
      : [{ id: '00000000-0000-0000-0000-000000000000', title: '' }];

  const summaries = [
    {
      header: 'Lender Name',
      accessorKey: 'firstLender',
      type: 'text',
      required: false,
      value: equityInfo ? equityInfo.firstLender : '',
      tab: 1
    },
    {
      header: 'Mortgage Balance',
      accessorKey: 'firstMortgageBalance',
      type: 'money',
      required: false,
      value: equityInfo ? equityInfo.firstMortgageBalance : '',
      tab: 1
    },
    {
      header: 'Escrow Balance',
      accessorKey: 'firstMortgageEscrowBalance',
      type: 'money',
      required: false,
      value: equityInfo ? equityInfo.firstMortgageEscrowBalance : '',
      tab: 1
    },
    {
      header: 'Interest Rate',
      accessorKey: 'firstMortgageInterestRate',
      type: 'number',
      required: false,
      value: equityInfo ? equityInfo.firstMortgageInterestRate : '',
      tab: 1
    },

    {
      header: 'Int Proration Date',
      accessorKey: 'firstMortgageProrationDate',
      type: 'date',
      required: false,
      value: equityInfo ? equityInfo.firstMortgageProrationDate : '',
      tab: 1
    },
    {
      header: 'Int Proration Amount',
      accessorKey: 'firstMortgageProrationAmount',
      type: 'money',
      required: false,
      value: equityInfo ? equityInfo.firstMortgageProrationAmount : '',
      tab: 1
    },
    {
      header: 'Proration Days',
      accessorKey: 'prorationDaysTypeId',
      type: 'dropdown-v2',
      options: prorationDaysOptions,
      required: false,
      value: equityInfo ? equityInfo.prorationDaysTypeId : '',
      tab: 1
    },
    {
      header: 'P&I Payment',
      accessorKey: 'firstMortgagePAndI',
      type: 'money',
      required: false,
      value: equityInfo ? equityInfo.firstMortgagePAndI : '',
      tab: 1
    },
    {
      header: 'Last Payment Date',
      accessorKey: 'firstMortgageLastPayment',
      type: 'date',
      required: false,
      value: equityInfo ? equityInfo.firstMortgageLastPayment : '',
      tab: 1
    },

    {
      header: 'Lender Name',
      accessorKey: 'secondLender',
      type: 'text',
      required: false,
      value: equityInfo ? equityInfo.secondLender : '',
      tab: 2
    },
    {
      header: 'Mortgage Balance',
      accessorKey: 'secondMortgageBalance',
      type: 'money',
      required: false,
      value: equityInfo ? equityInfo.secondMortgageBalance : '',
      tab: 2
    },
    {
      header: 'Interest Rate',
      accessorKey: 'secondMortgageInterestRate',
      type: 'number',
      required: false,
      value: equityInfo ? equityInfo.secondMortgageInterestRate : '',
      tab: 2
    },
    {
      header: 'Int Proration Date',
      accessorKey: 'secondMortgageProrationDate',
      type: 'date',
      required: false,
      value: equityInfo ? equityInfo.secondMortgageProrationDate : '',
      tab: 2
    },
    {
      header: 'Int Proration Amt',
      accessorKey: 'secondInterestProrationAmount',
      type: 'money',
      required: false,
      value: equityInfo ? equityInfo.secondInterestProrationAmount : '',
      tab: 2
    },
    {
      header: 'Proration Days',
      accessorKey: 'secondMortgageProrationDaysTypeId',
      type: 'dropdown-v2',
      options: prorationDaysOptions,
      required: false,
      value: equityInfo ? equityInfo.secondMortgageProrationDaysTypeId : '',
      tab: 2
    },
    {
      header: 'P&I Payment',
      accessorKey: 'secondMortgagePAndI',
      type: 'money',
      required: false,
      value: equityInfo ? equityInfo.secondMortgagePAndI : '',
      tab: 2
    },
    {
      header: 'Last Payment Date',
      accessorKey: 'secondMortgageLastPayment',
      type: 'date',
      required: false,
      value: equityInfo ? equityInfo.secondMortgageLastPayment : '',
      tab: 2
    }
  ];

  const updateFields = async (tab, values) => {
    setIsLoading(true);

    let newValues = { ...equityInfo };

    if (tab === 1) {
      newValues.firstLender = values.firstLender;
      newValues.firstMortgageBalance = values.firstMortgageBalance;
      newValues.firstMortgageEscrowBalance = values.firstMortgageEscrowBalance;
      newValues.firstMortgageEscrow = values.firstMortgageEscrow;
      newValues.firstMortgageInterestRate = values.firstMortgageInterestRate;
      newValues.firstMortgageLastPayment = values.firstMortgageLastPayment;
      newValues.firstMortgagePayment = values.firstMortgagePayment;
      newValues.primaryInterestDueFrom = values.primaryInterestDueFrom;
      newValues.firstMortgagePAndI = values.firstMortgagePAndI;
      newValues.firstMortgageProrationDate = values.firstMortgageProrationDate;
      newValues.firstMortgageProrationAmount = values.firstMortgageProrationAmount;
      newValues.firstMortgagePrincipal = values.firstMortgagePrincipal;
      newValues.firstMortgageExpCode = values.firstMortgageExpCode;
      newValues.prorationDaysTypeId = values.prorationDaysTypeId;
      newValues.firstMortgageTypeId = ZERO_GUID;
    } else if (tab === 2) {
      newValues.secondMortgageTypeId = ZERO_GUID;
      newValues.secondLender = values.secondLender;
      newValues.secondMortgageBalance = values.secondMortgageBalance;
      newValues.secondMortgageInterestRate = values.secondMortgageInterestRate;
      newValues.secondMortgageLastPayment = values.secondMortgageLastPayment;
      newValues.secondMortgagePAndI = values.secondMortgagePAndI;
      newValues.secondMortgageProrationDate = values.secondMortgageProrationDate;
      newValues.secondInterestProrationAmount = values.secondInterestProrationAmount;
      newValues.secondMortgageProrationDaysTypeId = values.secondMortgageProrationDaysTypeId;
    }

    const resp = await props.updateEquity(fileId, newValues);
    if (resp.type === UPDATE_LISTINGS_FAILURE) {
      props.showToast('Failed to update equity info, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      setIsLoading(false);
      return false;
    } else {
      await props.getHomesaleInfo(fileId);
      setIsLoading(false);
      return true;
    }
  };

  return (
    <EditableCard
      tabs={tabs}
      summaries={summaries}
      numColumns={3}
      updateFields={updateFields}
      isLoading={isLoading}
      hideEdit={isReadOnly}
    />
  );
};

const mapStateToProps = state => {
  const { prorationDayesTypes, equityTypes } = state.enumerations.allEnums;
  return {
    prorationDayesTypesEnum: prorationDayesTypes,
    equityTypesEnum: equityTypes
  };
};

export default compose(
  connect(mapStateToProps, {
    updateEquity,
    showToast,
    getHomesaleInfo
  })
)(EquityDetailsCard);
